import baseApi from "store/api/baseApi";
import comparePassword from "utils/comparePassword";

const authManagementApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    userRegister: builder.mutation({
      query: data => {
        return {
          url: `qwikITUser/new/`,
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["auth", "user"],
      transformResponse: response => {
        if (response) {
          return response;
        }
      },
    }),
    userLogin: builder.mutation({
      queryFn: async (data, _queryApi, _extraOptions, baseQuery) => {
        try {
          // 1. Fetch all users
          const response = await baseQuery({
            url: `qwikITUser/`,
            method: "GET",
          });

          if (response.error) {
            return { error: response.error };
          }

          const users = response.data;

          // 2. Find user by email
          const user = users.find(u => u.personal_email === data.email);
          if (!user) {
            return { error: { status: 404, data: "User not found" } };
          }

          // 3. Compare password
          const isPasswordValid = await comparePassword(
            data.password,
            user.password_hash
          );
          if (!isPasswordValid) {
            return { error: { status: 401, data: "Invalid password" } };
          }

          // 4. Success
          return { data: user }; // ✅ Return inside { data }
        } catch (err) {
          console.error(err);
          return { error: { status: 500, data: "Internal server error" } };
        }
      },
    }),
  }),
});

export const { useUserRegisterMutation, useUserLoginMutation } =
  authManagementApi;
